/* eslint-disable react-hooks/rules-of-hooks */
import { pickDefaultModelResult } from '@upright/common/model/data-point-pickers';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useWeightSetItemResults } from '../../../../api/model/output/scores/weight-sets';
import { getTextStyle } from '../../../../common/generic/content/texts/bou-text/text-style';
import { TopHoldingsTable } from '../../../../common/upright/model/output/scores/top-holdings-table';
import { TopHoldingsTableType } from '../../../../common/upright/model/output/scores/top-holdings-table/types';
import { getDefaultRelease } from '../../../../untidy/redux/selectors';
import { useRenderViewContext } from '../../context';

export const RenderViewTopHoldingsTable = () => {
  const context = useRenderViewContext();
  const { release: releaseOption } = context.options;
  const release = releaseOption ?? useSelector(getDefaultRelease);

  // TODO OA: Change to fetch own data with ReactQuery instead of getting it from RenderViewContext
  const scoreData = context.data?.[0];
  const modelResults = scoreData?.modelResults;
  const modelResult = modelResults && pickDefaultModelResult(modelResults);
  const weightSetId = modelResult?.weightSetId;

  const itemsQuery = useWeightSetItemResults(weightSetId, release, {
    includeEuTaxonomyMetrics: false,
    includePaiMetrics: false,
  });
  const itemData = itemsQuery.data;

  if (!scoreData || !itemData) {
    return <>Loading items...</>;
  }

  return (
    <Root>
      <TitleAndTableWrap>
        <Title>Top holdings by net impact ratio</Title>
        <TopHoldingsTable
          type={TopHoldingsTableType.NET_IMPACT_RATIO}
          itemData={itemData}
          scoreData={scoreData}
          loadingFinished={true}
        />
      </TitleAndTableWrap>
      <TitleAndTableWrap>
        <Title>Top holdings by weight</Title>
        <TopHoldingsTable
          type={TopHoldingsTableType.WEIGHT}
          itemData={itemData}
          scoreData={scoreData}
          loadingFinished={true}
        />
      </TitleAndTableWrap>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  > * + * {
    margin-left: 6%;
  }
  > * {
    width: 47%;
  }
`;

const TitleAndTableWrap = styled.div``;

const Title = styled.div`
  ${getTextStyle({ size: 'large', isBold: true })}
  margin-bottom: 1em;
`;
